gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const homeAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
/*       let homeBanner = document.querySelector(".homebanner");
      let expertiseCards = document.querySelectorAll(".homebanner-card"); */

      /* GSAP */

      gsap.from('.homebanner-card', {
        y: 100,
        opacity: 0,
        stagger: 0.1 // 0.1 seconds between when each ".box" element starts animating
    });


      const card1 = document.querySelector(".card1");
      const card2 = document.querySelector(".card2");
      const card3 = document.querySelector(".card3");
      const card4 = document.querySelector(".card4");
      //const bg1 = document.querySelector('.bg-card1');
      const bg2 = document.querySelector('.bg-card2');
      const bg3 = document.querySelector('.bg-card3');
      const bg4 = document.querySelector('.bg-card4');

      card1.addEventListener('mouseenter', () => {
        //bg1.style.opacity = 0;
        bg2.style.opacity = 0;
        bg3.style.opacity = 0;
        bg4.style.opacity = 0;
      })

      card2.addEventListener('mouseenter', () => {
        bg2.style.opacity = 1;
        //bg1.style.opacity = 0;
        bg3.style.opacity = 0;
        bg4.style.opacity = 0;
      })

      card3.addEventListener('mouseenter', () => {
        bg3.style.opacity = 1;
        bg2.style.opacity = 0;
        bg4.style.opacity = 0;
        //bg1.style.opacity = 0;
      })

      card4.addEventListener('mouseenter', () => {
        bg4.style.opacity = 1;
        bg2.style.opacity = 0;
        bg3.style.opacity = 0;
        //bg1.style.opacity = 0;
      })


    });
  },
};

export default homeAnim;
